{
  "headings": {
    "tenantLeaves_one": "One person is moving out",
    "tenantLeaves_other": "{{count}} people are moving out",
    "modificationPreview": "Preview of changes",
    "thankYou": "Thank you",
    "confirmationRejected": "Contract modification is rejected.",
    "addTenant": "Add tenant",
    "residentChangeType": "What would you like to report?",
    "whoMovesOut": "Who is moving out?",
    "contractPartiesMovingOut": "Which contract parties are moving out?",
    "contractTransfer": "Contract transfer"
  },
  "view": {
    "title": "Contract modifications"
  },
  "residentChanges": {
    "title": "Resident changes",
    "description": "Use this page to report when a new resident moves into your apartment or when a resident who is not a contract party moves out. The contract continues as before.",
    "terminationInfo": "If you or another contract party is moving out, submit a notice of termination.",
    "rightOfOccupancyNoticeInfo": "If you or another contract party is moving out, submit a notice of handover.",
    "moveIn": "Moving in",
    "moveInDescription": "Moving in – add a new resident to the apartment.",
    "moveOut": "Moving out",
    "moveOutDescription": "Moving out – report that a resident who is not a contract party is moving out.",
    "pendingContractChanges": "You cannot report resident changes until the previous contract changes take effect."
  },
  "tenantChoices": {
    "lives": "Lives here",
    "movesOut": "Moves out",
    "staysInApartment": "Stays",
    "contractParty": "Contract party",
    "currentUserName": "{{name}} (you)"
  },
  "tenantRoles": {
    "tenant": "Resident",
    "subtenant": "Subtenant",
    "replacementApartmentTenant": "Resident of a temporary apartment",
    "legalGuardian": "Guardian",
    "secondaryTenant": "Secondary tenant",
    "minor": "{{role}}, under 18"
  },
  "labels": {
    "movingOutDate": "Moving out date",
    "modificationDescription": "Additional information",
    "transferDestination": "Whose name do you want to transfer the contract to",
    "movingOutTenant": "Tenant moving out",
    "newContractParty": "New contract party",
    "socialSecurityNumber": "Social security number",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email",
    "phoneNumber": "Phone number",
    "change": "Change",
    "personAdded": "Person added",
    "personInformation": "Person information",
    "contractEnds": "Ends",
    "contractEnded": "Ended"
  },
  "placeholders": {
    "modificationDescription": "You can optionally provide additional information"
  },
  "buttons": {
    "backToEdit": "Back to edit",
    "confirmModification": "Confirm contract changes",
    "rejectModification": "Reject contract changes",
    "back": "Back",
    "addPerson": "Add person",
    "restart": "Start over"
  },
  "links": {
    "goToTerminateContract": "Go to termination →",
    "goToRightOfOccupancyNotice": "Go to notice of handover →",
    "seeTerminateContract": "See Terminate the agreement →"
  },
  "texts": {
    "confirmationInstruction": "Review the submitted information and either approve or reject the contract changes. If the information needs to be edited, reject the changes and fill out the termination form again.",
    "tenantLeavingDescription": "The contract will remain valid, and responsibility for the apartment will transfer to the other contract parties.",
    "confirmationAccepted": "The change notification has been confirmed by you.",
    "terminationRequestExists": "A termination request has already been made for this contract.",
    "returnFromAuthReminder": "Please note that the contract modification notice is only submitted for processing once you have completed strong authentication and returned to the resident pages. If authentication is interrupted, the modification remains incomplete.",
    "otherContractPartyTerminationInfo": "Another contract party can only be terminated by terminating the whole contract. In that case, select The whole contract ends.",
    "selectMovingOutTenants": "Select the people who are moving out.",
    "contractPartyMoveOut": "If a contract party is moving out, submit a notice of termination on the Terminate the agreement page.",
    "rightOfOccupancyNoticeContractPartyMoveOut": "If a contract party is moving out, submit a notice of handover on the Terminate the agreement page.",
    "moveOutDateRange": "Choose a date between {{start}} and {{end}}.",
    "monthEndMoveOutDate": "Please choose the last day of the month, {{date}} at the earliest.",
    "addTenantDescription": "Add the details of the person moving into the apartment.",
    "contractTransferInfo": "The contract continues and responsibility for the apartment transfers to the person you selected. The change is submitted for processing once all parties have confirmed it."
  },
  "terminationDisallowedReasons": {
    "pending": "Pending",
    "endsOn": "Ends {{date}}",
    "contract_terminated": "The contract has already been terminated.",
    "pending_termination_tenant_approvals": "Not all tenants have approved the termination yet.",
    "pending_termination_review": "The termination notice is awaiting review by the property company.",
    "is_estate_contract": "The contract belongs to an estate of a deceased person.",
    "has_guardian_of_interests": "One of the contracting parties has a legal guardian.",
    "missing_resident_users": "Not all contracting parties have a resident portal account.",
    "contract_tag": "The contract has a tag that prevents termination.",
    "not_contract_party": "You are not a party to this contract.",
    "tenants_with_undetermined_age": "The contract includes residents whose age is not known.",
    "has_company_tenant": "The contract has a company as a party.",
    "pending_modification_request": "An open modification request prevents termination.",
    "not_started_yet": "The contract has not yet started.",
    "open_continuation_offer": "An open continuation offer prevents termination."
  },
  "confirmationError": {
    "noIdentityVerifier": "User identity could not be verified",
    "noIdentity": "User identity could not be processed",
    "noUser": "An error occurred while fetching user information",
    "noAttributes": "User personal details are incomplete",
    "identityMismatch": "Identity does not match the logged-in user",
    "initFailed": "An error occurred while confirming the contract modification notice",
    "cancelled": "Authentication cancelled",
    "addTenantInitFailed": "Adding tenant failed"
  },
  "errors": {
    "outOfService": "Unfortunately, contract modification is not currently possible. Please try again later.",
    "formErrorTitle": "Error sending contract modification notice",
    "confirmErrorTitle": "Error confirming contract modification notice",
    "pending_contract_resign": "The contract is waiting for re-signing."
  },
  "confirmationState": {
    "modificationConfirmed": "The change notification has been sent",
    "modificationPending": "The change notification has been sent and is awaiting approval from other parties",
    "modificationRejected": "The sending of the change notification has been canceled",
    "modificationNotFound": "No information found with the change notification ID",
    "modificationLoading": "Loading the status of the change notification...",
    "addTenantSuccess": "The change has been saved"
  }
}
